var _g, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncognito(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.2,
    height: 22.2,
    viewBox: "0 0 22.2 22.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "private-eye"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.7,12.2A11.1,11.1,0,1,1,11.8,23.3,11.14,11.14,0,0,1,.7,12.2Zm1.6,0a9.56,9.56,0,0,0,9.5,9.5,9.5,9.5,0,0,0,0-19A9.56,9.56,0,0,0,2.3,12.2Z",
    transform: "translate(-0.7 -1.1)",
    fill: "#{props.color}",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Capa_13",
    "data-name": "Capa 13"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.8,5.7a2.54,2.54,0,0,1,.7.2c.7.2,1.4.4,2,.6h.4L14,5.9a1.93,1.93,0,0,1,2.5,1.4c.3,1.2.6,2.4.9,3.7,0,.2.1.2.3.3s.6.1.9.1a.37.37,0,0,1,.4.4.35.35,0,0,1-.5.3,19.42,19.42,0,0,0-2.4-.2c-1.3-.1-2.5-.2-3.8-.2-1.6,0-3.2.1-4.9.2a21.3,21.3,0,0,0-2.5.3H4.7c-.2,0-.4-.1-.4-.3a.37.37,0,0,1,.4-.4c.3,0,.6-.1.9-.1a.27.27,0,0,0,.3-.3c.3-1.2.6-2.5,1-3.7A2.1,2.1,0,0,1,8.8,5.7ZM6.7,11a54.56,54.56,0,0,1,9.9,0l-.9-3.6a1.13,1.13,0,0,0-1.5-.8c-.8.2-1.5.5-2.3.7h-.5c-.8-.2-1.5-.5-2.3-.7a1.07,1.07,0,0,0-1.4.8c-.1.2-.1.5-.2.7C7.2,9.1,7,10,6.7,11Z",
    transform: "translate(-0.7 -1.1)",
    fill: "{props.color}",
    stroke: "#{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3,15.2a6.6,6.6,0,0,1,2.8,0c.1-.2.1-.3.2-.4a2.64,2.64,0,0,1,2.5-1.6,2.46,2.46,0,0,1,2.3,1.7,2.52,2.52,0,0,1-.9,2.8,2.54,2.54,0,0,1-4.1-1.5c0-.2-.1-.2-.2-.2a9.64,9.64,0,0,0-2.4,0,.22.22,0,0,0-.2.2,2.67,2.67,0,0,1-2.5,2.1,2.58,2.58,0,0,1-2.5-1.9,2.54,2.54,0,0,1,4.9-1.3C10.3,15,10.3,15.1,10.3,15.2Zm5.3-1.3a1.8,1.8,0,1,0,1.8,1.8A1.79,1.79,0,0,0,15.6,13.9ZM7.8,17.4A1.8,1.8,0,1,0,6,15.6,1.79,1.79,0,0,0,7.8,17.4Z",
    transform: "translate(-0.7 -1.1)",
    fill: "{props.color}",
    stroke: "#{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-0.7 -1.1)",
    fill: "#{props.color}",
    stroke: "#{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5,18",
    transform: "translate(-0.7 -1.1)",
    fill: "none",
    stroke: "#{props.color}",
    strokeMiterlimit: 10,
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.53,23.3",
    transform: "translate(-0.7 -1.1)",
    stroke: "#{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.63,15.41",
    transform: "translate(-0.7 -1.1)",
    fill: "#{props.color}",
    stroke: "#{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncognito);
export default __webpack_public_path__ + "static/media/incognito.9fc9d49f77bcbb22cb5ba8e17c05fe02.svg";
export { ForwardRef as ReactComponent };